import axios from '@/util/axios'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * プロフィール取得API
 * @param  {} params={}
 */
export const fetch = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/PR/001', r)
    .catch(handleError)
}

/**
 * プロフィール更新API
 * @param  {} params={}
 */
export const update = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  // アラート書籍削除用に空配列で送信せずに、[0]を送信
  if (params.alert_books && params.alert_books.length === 0) {
    params.alert_books = [0]
  }

  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/PR/002', r)
    .catch(handleError)
}

/**
 * プロフィール更新API（ファイル送信）
 * @param  {} params={}
 */
export const updateProfileImage = (file, type, id) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = new FormData()
  r.append('token', token)
  r.append('organization_id', organizationId)
  r.append('file', file)
  r.append('profile_image_upload', type)
  r.append('user_id', id)

  const options = {
    ...NEW_API_CONFIG,
    headers: {
      'content-type': 'multipart/form-data'
    },
    responseType: type === '1' ? 'arraybuffer' : 'json'
  }

  const newAxios = axios.create(options)
  return newAxios.post('/PR/002', r)
    .catch(handleError)
}

/**
 * パスワード変更（メール送信）API
 * @param  {} params={}
 */
export const changePassword = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = { 
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/PR/003', r)
    .catch(handleError)
}
